<template>
    <div class="modal fade" :id="'createAttributeModal_'+modalId" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <form @submit.prevent="submitData" class="form">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ modalId == "create" ? $t('attributes.creation') : $t('attributes.modification')}}</h5>
                        <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal" aria-label="Close">
                            <span class="svg-icon svg-icon-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                                        fill="currentColor"/>
                                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                                        fill="currentColor"/>
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div class="modal-body">
                        <RequiredText />
                        <div class="d-flex flex-column mb-8 fv-row">
                            <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                                <span class="required">{{$t('attributes.name')}}</span>
                            </label>
                            <input type="text" class="form-control form-control-solid" v-model="formData.name" :placeholder="$t('attributes.name_placeholder')" required />
                        </div>
                        <div class="d-flex flex-column mb-8 fv-row" v-if="modalId == 'create'">
                            <label class="d-flex align-items-center fs-6 fw-bold mb-2" for="">{{ $t('attributes.values') }}<span class="text-danger">*</span> </label>
                            <input :id="'kt_tagify_add_'+modalId" class="form-control tagify " type="text" required/>
                            <small id="attributeHelpBlock" class="form-text text-muted"> {{ $t('attributes.tag_input_text') }} </small>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <Button btn-class="btn-sm me-2" type="cancel" btn-text="button.close" size="7px 30px" @click="closeModal"/>
                        <Button btn-class="btn-sm" type="submit" btn-text="button.save" size="7px 30px" :isLoading="isLoadingAttribute"/>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>

    import {ref, defineProps, onMounted, watch, nextTick} from 'vue'
    import {useStore} from "vuex";
    import RequiredText from "@/components/RequiredText"
    import Button from "@/components/Button.vue"

    const store = useStore()

    const props = defineProps({
        attribut: { 
            type: Object, 
            default: {
                name: '',
                variation: []
            } 
        },
        id : {
            type: String,
            required: true
        },
        parent: {
            type: String,
            required: true
        },
        hasParent: {
            type: Boolean,
            required: false
        },
    })

    const emits = defineEmits(['load', 'addAttribut'])

    const isLoadingAttribute = ref(false)
    const parentId = ref(props.parent)
    const modalId = ref(props.id)
    const formData = ref(props.attribut)

    let addVariation

    function submitData(){
        if(modalId.value == "create"){
            createAttributeData()
        }else{
            updateAttributeData()
        }
    }

    watch(() => props.attribut, (value) => {
      formData.value = value
    }, {deep : true})


    watch(() => modalId.value, () => {
        nextTick(() => {
            tagifyAdd()
        })
    })

    onMounted(() => {
        tagifyAdd()
    })

    function closeModal(){
        $('#createAttributeModal_'+modalId.value).modal('toggle')
        if(props.hasParent){
          $('#' + parentId.value).modal('toggle')
        }
    }

    function createAttributeData(){
        isLoadingAttribute.value = true
        store.dispatch('attributs/createAttribut', formData.value)
            .then((response) => {
                emits('addAttribut')
                emits('load')
                isLoadingAttribute.value = false
                closeModal()
                clearForm()
                window.toastr['success'](i18n.global.t('notification.attribute_created'))
            })
            .catch(err => {
                isLoadingAttribute.value = false
            })
    }

    function updateAttributeData(){
        isLoadingAttribute.value = true
        store.dispatch('attributs/updateAttribut', formData.value)
            .then((response) => {
                emits('load')
                isLoadingAttribute.value = false
                closeModal()
                clearForm()
                window.toastr['success'](i18n.global.t('notification.attribute_updated'))
            })
            .catch(err => {
                isLoadingAttribute.value = false
            })
    }

    function tagifyAdd(){
       var eAdd = document.getElementById("kt_tagify_add_"+modalId.value)
    
       if(eAdd){
            addVariation = new Tagify(eAdd)

            addVariation.on("invalid", function (e) {
                if (e.detail.data.__isValid === 'pattern mismatch') {
                window.toastr['error']('variation invalid')
                }
            })
            .on('add', () => {
                formData.value.variation = addVariation.value.map(x => x.value)
            })
            .on("remove", () => {
                formData.value.variation = addVariation.value.map(x => x.value)
            })
       }
    }

    function clearForm() {
        formData.value.id = '';
        formData.value.variation = [];
        formData.value.name = '';

        if (addVariation) {
            addVariation.removeAllTags();
        }
    }
</script>